import { watch } from '@vue/composition-api';
import type { Ref, ComputedRef } from '@vue/composition-api';
import { createInjection } from '@/lib/createInjection';

export interface SagyouPhaseState {
  isPreWork: boolean;
}

const { provide, inject } = createInjection<SagyouPhaseState>('johaisetsuSagyou/sagyouPhase');

// 親画面側: 現在表示中の子コンポーネントの画面フェーズを保持する
export function provideSagyouPhase(state: SagyouPhaseState): void {
  provide(state);
}

// 子コンポーネント側: 自身が「作業開始前の画面」かどうかを継続的に反映する
export function useSagyouPhase(isPreWork: Ref<boolean> | ComputedRef<boolean>): void {
  const state = inject();
  watch(isPreWork, val => {
    state.isPreWork = val;
  }, { immediate: true });
}
